import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Feature } from '../shared/feature';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { AuthService } from '../../ajs-upgraded-providers';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  features$ = new Subject<Feature[]>();
  recommendedFeatures$ = new Subject<String[]>();
  
  features : Feature[] = [];
  recommendedFeatures : String[] = [];

  constructor(private http : HttpClient,private authService : AuthService) {
    let  student =this.authService.isStudent();
    if(student) return;

    this.loadFeatures().subscribe((features : Feature[])=>{ 
      this.features = features;
      this.recommendedFeatures = this.getRecommendedFeatures(features);

      this.recommendedFeatures$.next(this.recommendedFeatures);
      this.features$.next(features);
    });
  }


  loadFeatures = () : Observable<Feature[]> => this.http.get<Feature[]>('../rl/config/featuresRecommendations');

  updateFeatures = (featuresChanges : {[code: string]: boolean}) : Observable<void> => this.http.patch<void>('../rl/config/updateFeatures' , featuresChanges); 
  
  getRecommendedFeatures = (features : Feature[]) : String[] => {
		return features.filter(feature => !feature.active).slice( 0, 5).map(feature => feature.code)
  }

} 
   